export const PLEASE_FILL_PASSWORD = "Please fill password";
export const PLEASE_FILL_USERNAME = "Please fill username";
export const USER_SESSION_EXPIRED = "Your session has expired. Please login again.";
